/**
 * Created by shani on 02/01/18.
 */
import { Injectable } from "@angular/core";

@Injectable()
export class InlineEditorService {

    // handleErrors(editors: InlineEditorComponent[]): Observable<InlineEditorErrorDTO[]>{
    //     let errors:InlineEditorErrorDTO[] = [];
    //     for(let editor of editors){
    //         const instance = editor.currentComponent.instance;
    //         let inlineEditorError = <IInlineEditorError[]>instance.checkValue();
    //         let element  = instance.inputRef.nativeElement;
    //         if(element.validationMessage){
    //             let obj = new InlineEditorErrorDTO({
    //                 'message': element.validationMessage,
    //                 'input':  element
    //             });
    //             let dto =  new InlineEditorErrorDTO(obj);
    //             errors.push(dto);
    //         }
    //          else if(inlineEditorError.length){
    //             for (let obj of inlineEditorError){
    //                 obj.input = element;
    //                 let dto =  new InlineEditorErrorDTO(obj);
    //                 errors.push(dto);
    //             }
    //         }
    //     }
    //     return Observable.of(errors);
    // }
}
